import ScheduledDeliveriesRoutes from './routes'
export default ScheduledDeliveriesRoutes



// WEBPACK FOOTER //
// ./src/containers/drivers/routes/index.js